module.exports = __webpack_public_path__ + "static/q11_o-a235fe41337a1630d6551c6924cb9862.png";